export default __webpack_public_path__ + "static/media/man-left-2.8b39e914.svg";